var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSleepQuality = function SvgIconSleepQuality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M1 14.9h3l3-7 6 14 3-7h7m-6-10V3c-2 .5-3.4 2.6-2.9 4.8.3 1.4 1.5 2.6 2.9 2.9 2.3.5 4.3-.9 4.8-2.9H20c-1.7.1-3-1.2-3-2.9z"
  }))));
};
export { SvgIconSleepQuality as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPHBhdGggZD0iTTEgMTQuOWgzbDMtNyA2IDE0IDMtN2g3TTE3IDQuOVYzYy0yIC41LTMuNCAyLjYtMi45IDQuOC4zIDEuNCAxLjUgMi42IDIuOSAyLjkgMi4zLjUgNC4zLS45IDQuOC0yLjlIMjBjLTEuNy4xLTMtMS4yLTMtMi45eiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";